// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import TextInput from 'components/inputs/TextInput';
import TimezoneInput from 'components/inputs/TimezoneInput';
import ImageUploadInput from 'components/inputs/ImageUploadInput';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
// CONSTANTS & DESCTRUCTURING
// ====================================
import saveUserImage from 'ApolloClient/Mutations/saveUserImage';
import { graphql } from 'react-apollo';
import message from 'antd/lib/message';
import Form from 'components/common/Form';

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;

// EXPORTED COMPONENT
// ====================================
class UserForm extends React.PureComponent {
  state = {
    email: this.props.user.emails && this.props.user.emails[0] && this.props.user.emails[0].address,
    firstName: this.props.user.profile && this.props.user.profile.firstName,
    lastName: this.props.user.profile && this.props.user.profile.lastName,
    image: this.props.user.profile && this.props.user.profile.image,
    timezone: this.props.user.profile && this.props.user.timezone,
  };

  onSubmit = () => {
    this.props.handleSubmit(this.state);
  };

  saveImage = async variables => {
    try {
      await this.props.saveUserImage({ variables });
    } catch (err) {
      return console.log(err);
    }
    message.success('Avatar saved!');
  };

  onChange = newValue => {
    if (newValue.image) {
      this.saveImage(newValue);
    }
    this.setState(newValue);
  };

  render() {
    return (
      <Form onSubmit={this.onSubmit}>
        <FormItem
          containerProps={{
            style: { display: 'flex', justifyContent: 'center' },
          }}
        >
          <ImageUploadInput
            cloudinaryOptions={{ croppingAspectRatio: 0.5, maxImageHeight: 150, maxImageWidth: 150 }}
            value={this.state.image}
            onChange={image => this.onChange({ image })}
          />
        </FormItem>
        <FormItem label="Email">
          <TextInput value={this.state.email} onChange={email => this.onChange({ email: email.toLowerCase() })} />
        </FormItem>
        <FormItem label="First Name">
          <TextInput value={this.state.firstName} onChange={firstName => this.onChange({ firstName })} />
        </FormItem>
        <FormItem label="Last Name">
          <TextInput value={this.state.lastName} onChange={lastName => this.onChange({ lastName })} />
        </FormItem>
        <FormItem label="Timezone">
          <TimezoneInput value={this.state.timezone} onChange={timezone => this.onChange({ timezone })} />
        </FormItem>
        <ButtonContainer>
          <Button disabled={this.props.loading} loading={this.props.loading} onClick={this.onSubmit} fullWidth>
            {!this.props.loading ? this.props.onOkText : 'Submitting...'}
          </Button>
        </ButtonContainer>
      </Form>
    );
  }
}

// PROPS
// ====================================
UserForm.defaultProps = {
  user: {},
  loading: false,
  onOkText: 'Save Changes',
};

// EXPORT
// ====================================
export default graphql(saveUserImage, { name: 'saveUserImage' })(UserForm);



// WEBPACK FOOTER //
// ./src/components/forms/UserForm/index.js